var TimeoutWrapper = (function () {
    function TimeoutWrapper() {
        this.promiseFinally = function (promise, fn) {
            var success = function (result) {
                fn();
                return result;
            };
            var error = function (e) {
                fn();
                return Promise.reject(e);
            };
            return Promise.resolve(promise).then(success, error);
        };
        this._id = null;
        this._delay = null;
    }
    TimeoutWrapper.wrap = function (promise, delay, rejectReason) {
        if (rejectReason === void 0) { rejectReason = ''; }
        return new TimeoutWrapper().wrap(promise, delay, rejectReason);
    };
    Object.defineProperty(TimeoutWrapper.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimeoutWrapper.prototype, "delay", {
        get: function () {
            return this._delay;
        },
        enumerable: false,
        configurable: true
    });
    TimeoutWrapper.prototype.set = function (delay, rejectReason) {
        var _this = this;
        if (rejectReason === void 0) { rejectReason = ''; }
        return new Promise(function (resolve, reject) {
            _this.clear();
            var fn = rejectReason ? function () { return reject(new Error((rejectReason))); } : resolve;
            _this._id = setTimeout(fn, delay);
            _this._delay = delay;
        });
    };
    TimeoutWrapper.prototype.wrap = function (promise, delay, rejectReason) {
        var _this = this;
        if (rejectReason === void 0) { rejectReason = ''; }
        var wrappedPromise = this.promiseFinally(promise, function () { return _this.clear(); });
        var timer = this.set(delay, rejectReason);
        return Promise.race([
            wrappedPromise,
            timer
        ]);
    };
    TimeoutWrapper.prototype.clear = function () {
        if (this._id) {
            clearTimeout(this._id);
        }
    };
    return TimeoutWrapper;
}());
export { TimeoutWrapper };
//# sourceMappingURL=TimeOutWrapper.js.map